// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-Breadcrumb-___Breadcrumb-module__breadcrumbLink {
  text-decoration: none !important;
  display: flex;
  align-items: center;
  align-content: center;
  cursor: pointer;
}

  .app-components-Breadcrumb-___Breadcrumb-module__breadcrumbLink:hover {
    text-decoration: underline !important;
  }

.app-components-Breadcrumb-___Breadcrumb-module__icon {
  margin-right: 5px;
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./app/components/Breadcrumb/Breadcrumb.module.scss"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AAKjB;;EAHE;IACE,qCAAqC;EACvC;;AAGF;EACE,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".breadcrumbLink {\n  text-decoration: none !important;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline !important;\n  }\n}\n\n.icon {\n  margin-right: 5px;\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breadcrumbLink": `app-components-Breadcrumb-___Breadcrumb-module__breadcrumbLink`,
	"icon": `app-components-Breadcrumb-___Breadcrumb-module__icon`
};
export default ___CSS_LOADER_EXPORT___;
